/* addToCalendar - add events to your calendars
 *  jQuery plugin
 * ================
 *
 * @Author  Farhadur Rahim
 * @version 1.0.1
 * @Licence: http://codecanyon.net/wiki/support/legal-terms/licensing-terms/
 */

(function(a){"use strict";a.fn.addToCalendar=function(b){var c={},d=a.extend({filename:"sample",target:"_blank",providers:{google:"Google Calendar",outlook:"Outlook Live",yahoo:"Yahoo! Calendar",other:"Other Calendar"},onAddEvent:function(){}},b),e=function(a,b){var c,e,f,h,i,j,k;if(c=void 0===b.title?"":b.title,e=void 0===b.start?new Date().toISOString():g(b.start),f=void 0===b.end?new Date().toISOString():g(b.end),h=void 0===b.desc?"":b.desc,i=void 0===b.location?"":b.location,k=void 0===b.timezone?"":b.timezone,"google"===a)j="http://www.google.com/calendar/render?action=TEMPLATE",j+="&text="+encodeURIComponent(c),j+="&dates="+encodeURIComponent(e+"/"+f),j+="&details="+encodeURIComponent(h),j+="&location="+encodeURIComponent(i),j+=k?"&ctz="+encodeURIComponent(k):"",j+="&output=xml",window.open(j,d.target);else if("outlook"===a)e=g(b.start,"outlook"),f=g(b.end,"outlook"),j="https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&subject="+encodeURIComponent(c)+"&startdt="+encodeURIComponent(e)+"&enddt="+encodeURIComponent(f)+"&body="+encodeURIComponent(h)+"&location="+encodeURIComponent(i),window.open(j,d.target);else if("yahoo"===a)j="https://calendar.yahoo.com/?v=60&view=d&type=20&title="+encodeURIComponent(c)+"&st="+encodeURIComponent(e)+"&et="+encodeURIComponent(f)+"&desc="+encodeURIComponent(h)+"&in_loc="+encodeURIComponent(i),window.open(j,d.target);else if("other"===a){var l,m=d.filename+".ics",n=new Date().toISOString().split(".")[0].replace(/[/]|-|:/g,""),o="BEGIN:VCALENDAR\n";o+="VERSION:2.0\n",o+="BEGIN:VEVENT\n",o+="DTSTAMP:"+n+"\n",o+="STATUS:CONFIRMED\n",o+="UID:"+new Date().getTime()+"addtocalendar\n",o+=""===k?"DTSTART="+e+"\n":"DTSTART;TZID="+k+":"+e+"\n",o+=""===k?"DTEND="+e+"\n":"DTEND;TZID="+k+":"+f+"\n",o+="SUMMARY:"+c+"\n",o+="DESCRIPTION:"+h+"\n",o+="X-ALT-DESC;FMTTYPE=text/html:"+h+"\n",o+="LOCATION:"+i+"\n",o+="BEGIN:VALARM\n",o+="TRIGGER:-PT15M\n",o+="ACTION:DISPLAY\n",o+="END:VALARM\n",o+="TRANSP:OPAQUE\n",o+="END:VEVENT\n",o+="END:VCALENDAR",l=document.createElement("a"),l.setAttribute("href","data:text/calendar;charset=utf-8,"+encodeURIComponent(o)),l.setAttribute("download",m),l.style.display="none",document.body.appendChild(l),l.click(),document.body.removeChild(l)}else return!1;return!0},f=function(a){var b=document.createElement("ul");return b.className="cal-clients",Object.keys(a).forEach(function(c){var d=document.createElement("li");d.textContent=a[c],d.className=c.toLowerCase(),b.appendChild(d)}),b},g=function(a,b){return"outlook"===b?(a=a.replace(/\//g,"-")+":00",a=a.replace(/\s/,"T")):(a=a.replace(/-|:|[/]|\.\d\d\d/g,"")+"00",a=a.replace(/\s/,"T")),a};return this.each(function(){var b=a(this);b.append(new f(d.providers)).mouseleave(function(){var b=a(this).find(".cal-clients");a(document).click(function(){b.removeClass("is-open"),a(document).unbind("click")})}).on("click",function(b){var d=a(this).find(".cal-clients");b.preventDefault(),c=a(this).data("event"),d.addClass("is-open")}).on("click","li",function(){var b=a(this).attr("class");e(b,c),d.onAddEvent.call(this)})})}})(jQuery);

var AddCalEventZones = {
    'A': '+01:00',
    'ACDT': '+10:30',
    'ACST': '+09:30',
    'ADT': '-03:00',
    'ADT': '-03:00',
    'AEDT': '+11:00',
    'AEST': '+10:00',
    'AFT': '+04:30',
    'AKDT': '-08:00',
    'AKST': '-09:00',
    'ALMT': '+06:00',
    'AMST': '+05:00',
    'AMST': '-03:00',
    'AMT': '+04:00',
    'AMT': '-04:00',
    'ANAST': '+12:00',
    'ANAT': '+12:00',
    'AQTT': '+05:00',
    'ART': '-03:00',
    'AST': '+03:00',
    'AST': '-04:00',
    'AST': '-04:00',
    'AST': '-04:00',
    'AWDT': '+09:00',
    'AWST': '+08:00',
    'AZOST': '+00:00',
    'AZOT': '-01:00',
    'AZST': '+05:00',
    'AZT': '+04:00',
    'B': '+02:00',
    'BNT': '+08:00',
    'BOT': '-04:00',
    'BRST': '-02:00',
    'BRT': '-03:00',
    'BST': '+06:00',
    'BST': '+01:00',
    'BTT': '+06:00',
    'C': '+03:00',
    'CAST': '+08:00',
    'CAT': '+02:00',
    'CCT': '+06:30',
    'CDT': '-04:00',
    'CDT': '-05:00',
    'CEST': '+02:00',
    'CET': '+01:00',
    'CET': '+01:00',
    'CHADT': '+13:45',
    'CHAST': '+12:45',
    'CKT': '-10:00',
    'CLST': '-03:00',
    'CLT': '-04:00',
    'COT': '-05:00',
    'CST': '+08:00',
    'CST': '-06:00',
    'CST': '-05:00',
    'CST': '-06:00',
    'CVT': '-01:00',
    'CXT': '+07:00',
    'ChST': '+10:00',
    'D': '+04:00',
    'DAVT': '+07:00',
    'E': '+05:00',
    'EASST': '-05:00',
    'EAST': '-06:00',
    'EAT': '+03:00',
    'EAT': '+03:00',
    'ECT': '-05:00',
    'EDT': '-04:00',
    'EDT': '-04:00',
    'EDT': '+11:00',
    'EEST': '+03:00',
    'EEST': '+03:00',
    'EEST': '+03:00',
    'EET': '+02:00',
    'EET': '+02:00',
    'EET': '+02:00',
    'EGST': '+00:00',
    'EGT': '-01:00',
    'EST': '-05:00',
    'EST': '-05:00',
    'EST': '-05:00',
    'ET': '-05:00',
    'ET': '-05:00',
    'ET': '-05:00',
    'F': '+06:00',
    'FJST': '+13:00',
    'FJT': '+12:00',
    'FKST': '-03:00',
    'FKT': '-04:00',
    'FNT': '-02:00',
    'G': '+07:00',
    'GALT': '-06:00',
    'GAMT': '-09:00',
    'GET': '+04:00',
    'GFT': '-03:00',
    'GILT': '+12:00',
    'GMT': '+00:00',
    'GMT': '+00:00',
    'GST': '+04:00',
    'GYT': '-04:00',
    'H': '+08:00',
    'HAA': '-03:00',
    'HAA': '-03:00',
    'HAC': '-05:00',
    'HADT': '-09:00',
    'HAE': '-04:00',
    'HAE': '-04:00',
    'HAP': '-07:00',
    'HAR': '-06:00',
    'HAST': '-10:00',
    'HAT': '-02:30',
    'HAY': '-08:00',
    'HKT': '+08:00',
    'HLV': '-04:30',
    'HNA': '-04:00',
    'HNA': '-04:00',
    'HNA': '-04:00',
    'HNC': '-06:00',
    'HNC': '-06:00',
    'HNE': '-05:00',
    'HNE': '-05:00',
    'HNE': '-05:00',
    'HNP': '-08:00',
    'HNR': '-07:00',
    'HNT': '-03:30',
    'HNY': '-09:00',
    'HOVT': '+07:00',
    'I': '+09:00',
    'ICT': '+07:00',
    'IDT': '+03:00',
    'IOT': '+06:00',
    'IRDT': '+04:30',
    'IRKST': '+09:00',
    'IRKT': '+09:00',
    'IRST': '+03:30',
    'IST': '+02:00',
    'IST': '+05:30',
    'IST': '+01:00',
    'JST': '+09:00',
    'K': '+10:00',
    'KGT': '+06:00',
    'KRAST': '+08:00',
    'KRAT': '+08:00',
    'KST': '+09:00',
    'KUYT': '+04:00',
    'L': '+11:00',
    'LHDT': '+11:00',
    'LHST': '+10:30',
    'LINT': '+14:00',
    'M': '+12:00',
    'MAGST': '+12:00',
    'MAGT': '+12:00',
    'MART': '-09:30',
    'MAWT': '+05:00',
    'MDT': '-06:00',
    'MESZ': '+02:00',
    'MEZ': '+01:00',
    'MHT': '+12:00',
    'MMT': '+06:30',
    'MSD': '+04:00',
    'MSK': '+04:00',
    'MST': '-07:00',
    'MUT': '+04:00',
    'MVT': '+05:00',
    'MYT': '+08:00',
    'N': '-01:00',
    'NCT': '+11:00',
    'NDT': '-02:30',
    'NFT': '+11:30',
    'NOVST': '+07:00',
    'NOVT': '+06:00',
    'NPT': '+05:45',
    'NST': '-03:30',
    'NUT': '-11:00',
    'NZDT': '+13:00',
    'NZDT': '+13:00',
    'NZST': '+12:00',
    'NZST': '+12:00',
    'O': '-02:00',
    'OMSST': '+07:00',
    'OMST': '+07:00',
    'P': '-03:00',
    'PDT': '-07:00',
    'PET': '-05:00',
    'PETST': '+12:00',
    'PETT': '+12:00',
    'PGT': '+10:00',
    'PHOT': '+13:00',
    'PHT': '+08:00',
    'PKT': '+05:00',
    'PMDT': '-02:00',
    'PMST': '-03:00',
    'PONT': '+11:00',
    'PST': '-08:00',
    'PST': '-08:00',
    'PT': '-08:00',
    'PWT': '+09:00',
    'PYST': '-03:00',
    'PYT': '-04:00',
    'Q': '-04:00',
    'R': '-05:00',
    'RET': '+04:00',
    'S': '-06:00',
    'SAMT': '+04:00',
    'SAST': '+02:00',
    'SBT': '+11:00',
    'SCT': '+04:00',
    'SGT': '+08:00',
    'SRT': '-03:00',
    'SST': '-11:00',
    'T': '-07:00',
    'TAHT': '-10:00',
    'TFT': '+05:00',
    'TJT': '+05:00',
    'TKT': '+13:00',
    'TLT': '+09:00',
    'TMT': '+05:00',
    'TVT': '+12:00',
    'U': '-08:00',
    'ULAT': '+08:00',
    'UTC': '+00:00',
    'UYST': '-02:00',
    'UYT': '-03:00',
    'UZT': '+05:00',
    'V': '-09:00',
    'VET': '-04:30',
    'VLAST': '+11:00',
    'VLAT': '+11:00',
    'VUT': '+11:00',
    'W': '-10:00',
    'WAST': '+02:00',
    'WAT': '+01:00',
    'WEST': '+01:00',
    'WEST': '+01:00',
    'WESZ': '+01:00',
    'WET': '+00:00',
    'WET': '+00:00',
    'WEZ': '+00:00',
    'WFT': '+12:00',
    'WGST': '-02:00',
    'WGT': '-03:00',
    'WIB': '+07:00',
    'WIT': '+09:00',
    'WITA': '+08:00',
    'WST': '+01:00',
    'WST': '+13:00',
    'WT': '+00:00',
    'X': '-11:00',
    'Y': '-12:00',
    'YAKST': '+10:00',
    'YAKT': '+10:00',
    'YAPT': '+10:00',
    'YEKST': '+06:00',
    'YEKT': '+06:00',
    'Z': '+00:00'
};

/* global jQuery */
/**
 * AddCalEvent.js

 * @author Mike Sendlakowski, msendlakowski@ebay.com
 *
 * Adds functionality to a button element to all users to add an event
 * to various calendar apps
 *
 * Usage:
 * All parameters are optional. However, if you want this to work for Outlook and iCal you must
 * provide the url that will generate the ics file response
 *
 * $(SELECTOR).addcalevent({
 *    'onclick': true,
 *    'apps': [1,2,4],
 *    'ics': '',
 *    'data': {}
 * });
 *
 * onclick: Open the dropdown on click rather than mouseover (default: false)
 * data: Event data (see below for format). This can also be set individually as a json string directly on each HTML element.
 * linkText: Array containing localized or customized text for the calendar links (order is critical)
 * ics: Url that will generate the server-side ics response based on the event details. Not optional if Outlook or iCal is needed.
 * apps: Array containing the applications available to the user. (default: [] - which is all apps)
 *            0 = Outlook
 *            1 = Google
 *            2 = Yahoo
 *            3 = Hotmail
 *            4 = iCal
 *
 * Format of event data object:
 *
 * title: '',
 * desc: '',
 * location: '',
 * url: '',         // only available in Yahoo calendars
 * organizer: {     // only available in Outlook
 *    name: '',
 *    email: ''
 * },
 * time: {
 *    start: '',    // 'month day, year 14:30:00'
 *    end: '',      // 'month day, year 14:30:00'
 *    zone: '',     // '+tt:tt' - plus or minus from UTC time zone (example: Pacific Daylight Time is '-07:00')
 *    allday: false
 * }
 *
 */

(function(window, $, undefined) {
    'use strict';

    // CONSTANTS
    var EVENT_SHOW = 'AddCalEvent:show',
    EVENT_ADDED = 'AddCalEvent:add',
    EVENT_INVALID = 'AddCalEvent:invalid',
    DEFAULT_EVENT = {
        title: '',
        desc: '',
        location: '',
        url: '',
        organizer: {name: '', email: ''},
        time: {
            start: '',
            end: '',
            zone: '00:00',
            allday: false
        }
    };

    $.addcalevent = function addcalevent(options, element) {
        this.el = $(element);
		// Flag the object in the event of a failed creation
		if (!this._create(options)) {
			this.failed = true;
		}
	};

	$.addcalevent.defaults = {
        onclick: false,
        apps: [],
        ics: '',
        preVal: true,
        disabledClass: "dis",
        linkText: [
            'Outlook Calendar',
            'Google Calendar',
            'Yahoo Calendar',
            'Hotmail Calendar',
            'iCal Calendar'
        ]
    };

    $.addcalevent.prototype = {

		/*	
		----------------------------
		Private methods
		----------------------------
		*/

		_create: function(options){
			this.options = $.extend(true, {}, $.addcalevent.defaults, options);
            if(this.options.preVal){
                this._disable(!this._sanitizeData());
            }
            this._attach();
            return true;
        },

        // add the basic hook to the button
        _attach: function() {
            var self = this;

            // handle clicking on a calendar link
            this.el.on('click', '.ace_opt', function(event){self._click(this, event);});

            // handle opening and closing the dropdown - always available for accessiblity
            this.el.on('click', function(event){self._clickShow(event);});
            $(document).on('click', function(){self._hide();});

            // handle opening and closing the dropdown on mouseover
            if(!this.options.onclick) {
                this.el.on('mouseover', function(){self._show();});
                this.el.on('mouseout', function(){self._hide();});
            }
        },

        // onclick handler for button (not calendar links)
        _clickShow: function(event) {
            if(this.open) {
                this._hide();
            } else {
                this._show();
                this.open = true;
            }
            event.stopPropagation();
        },
        
        // show the dropdown
        _show: function() {
            var self = this;
            if(!this.dd) {
                this._createDropdown();
            }
            this.dd.stop();
            this.dd.clearQueue();
            if(this.opening) {  // its already started animating, so finish it immediately
                this.dd.show();
                self.dd.css(self.ddCss);               
            } else {
                this.dd.show('fast');
                this.opening = true;
                this._eventPublisher(EVENT_SHOW);
            }
        },

        // hide the dropdown
        _hide: function() {
            var self = this;
            if(!this.dd) { // if it doesn't have a dropdown then no need to hide it. duh!
                return;
            }
            this.open = false;
            this.dd.stop();
            this.dd.clearQueue();
            this.dd.hide('fast', function(){    
                self.opening = false;
                self.dd.css(self.ddCss); // reset the height and opacity, because the jquery animation was losing it when we call stop
            });
        },

        // create the dropdown
        _createDropdown: function(showOpts) {
            var isValid = this._sanitizeData();
            this._disable(!isValid);
            this.dd = $(this._createHtml(isValid));
            this.el.append(this.dd);
            this.ddCss = {
                height: this.dd.css("height"),
                opacity: 1
            }
        },

        _disable:function(disable){
            this.el.toggleClass(this.options.disabledClass, disable);
        },

        // create the html for the dropdown
        _createHtml: function(isValid) {
            var styleString = this._getStyle(),
            optionLinks = '';
            for(var i=0,j=this.options.linkText.length;i<j;i++) {
                if(this._isLinkNeeded(i)) {
                    optionLinks += '<div class="ace_opt" data-ace-id="'+ i +'" >' + this.options.linkText[i] + '</div>';
                }
            }
            return '<div class="ace_dd" style="' + styleString + '">' + optionLinks + '</div>';
        },

        // test to see if we need to display this link
        _isLinkNeeded: function(linkId) {
            var isOK = false,
            appLength = this.options.apps.length;
            if(appLength === 0) {
                isOK = this._runIcsTest(linkId);
            } else {
                for(var y=0,z=this.options.apps.length;y<z;y++) {
                    if(this.options.apps[y] === linkId) {
                        isOK = this._runIcsTest(linkId);
                        break;
                    }
                }
            }
            return isOK;
        },

        // only show the outlook and ical links if the ics url is available
        _runIcsTest: function(linkId) {
            var isOK = false;
            if(linkId === 0 || linkId === 4) {
                if(this.options.ics !== '') {
                    isOK = true;
                }
            } else {
                isOK = true;
            }
            return isOK;
        },

        // get the absolute position and min-width based on the parent button
        // could cause issues if the button moves around the page dynamically when it resizes
        _getStyle: function() {
            var pos = this.el.position(),
            left = pos.left + parseFloat(this.el.css('marginLeft')),
            top = pos.top + this.el.outerHeight() + parseFloat(this.el.css('marginTop')) - 1,
            minwidth = this.el.outerWidth() - parseFloat(this.el.css('borderLeftWidth'));

            
            return 'min-width:' + minwidth + 'px;top:' + top + 'px;left:' + left + 'px';
        },

        // make sure all event data is available and valid 
        _sanitizeData: function() {
            var testData = this._getDataFromEl(),
            isValid = true,
            zoneRegex = /^[\+\-]?[0-9]{2}:[0-9]{2}/;

            if(!testData) {
                testData = this.options.data;
            }
            this.options.data = $.extend(true, {}, DEFAULT_EVENT, testData);
            this.options.data.timeObj = {};

            // is the start date valid?
            this.options.data.timeObj.start = new Date(this.options.data.time.start);
            if(isNaN(this.options.data.timeObj.start.getTime())) {
                isValid = false;
                this._eventPublisher(EVENT_INVALID, {invalidStartDate: this.options.data.time.start});
            }

            // is the end date valid?
            this.options.data.timeObj.end = new Date(this.options.data.time.end);
            if(isNaN(this.options.data.timeObj.end.getTime())) {
                isValid = false;
                this._eventPublisher(EVENT_INVALID, {invalidEndDate: this.options.data.time.end});
            }
            
            // is the time zone valid?
            this._lookupTimeZone();
            if(this.options.data.time.zone.length < 6) {
                this.options.data.time.zone = '+' + this.options.data.time.zone;
            }

            if(!zoneRegex.test(this.options.data.time.zone)) {
                isValid = false;
                this._eventPublisher(EVENT_INVALID, {invalidTimeZone: this.options.data.time.zone});
                this.options.data.time.zone = '+00:00';
            }

            return isValid;
        },

        // translates a time zone abbreviation to an offset, as long as
        // AddCalEventZones.js is loaded. But ideally the zone offset is identified on the server.
        _lookupTimeZone: function(){
            if(AddCalEventZones && AddCalEventZones[this.options.data.time.zone]) {
                this.options.data.time.zone = AddCalEventZones[this.options.data.time.zone];    
            }
        },

        // get the data from the html element rather than the plugin config
        _getDataFromEl: function(){
            var data = this.el.data('ace');
            if(typeof data === 'string') {
                this._eventPublisher(EVENT_INVALID, {invalidDataString: data});
                data = null;
            }
            return data;
        },

        // update the event options
        _update: function(options){
            this.options = $.extend(true, {}, $.addcalevent.defaults, options);
            if(this.options.preVal){
                this._disable(!this._sanitizeData());
            }
            return true;
        },

        // an event link was clicked
        _click: function(item, event) {
            var id = $(item).data('ace-id');
            this._addEvent(id);
            event.stopPropagation();
            this._hide();
        },

        // create an 'add to calendar' url and open it in a new window
        // most of the details were taken from this article:
        // http://richmarr.wordpress.com/2008/01/07/adding-events-to-users-calendars-part-2-web-calendars/
        _addEvent: function(calendarLinkType){
            var url,
                sameWindow;
            switch(calendarLinkType) {
            case 0:     //Outlook
            case 4:     // iCal
                url = this._getUrl_ics();
                sameWindow = true;
                break;
            case 1:     // Google
                url = this._getUrl_google();
                break;
            case 2:     // Yahoo
                url = this._getUrl_yahoo();
                break;
            case 3:     // Hotmail
                url = this._getUrl_hotmail();
                break;
            }
            if(url) {
                if(sameWindow) {
                    location.href = url;
                } else {
                    window.open(url, 'calendar');                    
                }
            }
            this._eventPublisher(EVENT_ADDED, {calendarLinkType: calendarLinkType, url: url});
        },

        _getUTCTime: function(dateObj) {
            var newDateObj = this._adjustToUTC(dateObj, this.options.data.time.zone);
            return this._getDatePart(newDateObj.getFullYear(),4) + this._getDatePart(newDateObj.getMonth()+1,2) + this._getDatePart(newDateObj.getDate(),2) + 'T' + this._getDatePart(newDateObj.getHours(),2) + this._getDatePart(newDateObj.getMinutes(),2) + this._getDatePart(newDateObj.getSeconds(),2) + 'Z';
        },

        // return a new date object based on dateObj and the zone
        _adjustToUTC: function(dateObj, zone){
            var dateOut = new Date(dateObj),
            hours, mins;

            if(isNaN(dateOut.getTime())) {
                return new Date();
            }

            // adjust to UTC
            hours = zone.substring(1,3);
            mins = zone.substring(4,6);
            if(zone.substring(0,1) === '-') {
                dateOut.setHours(dateOut.getHours() + (hours-0));
                dateOut.setMinutes(dateOut.getMinutes() + (mins-0));
            } else {
                dateOut.setHours(dateOut.getHours() - hours);
                dateOut.setMinutes(dateOut.getMinutes() - mins);
            }
            return dateOut;
        },

        _getDatePart: function(part, digits){
            part = part.toString();
            while(part.length < digits) {
                part = '0' + part;
            }
            return part;
        },
        
        _getDateDiff: function(startDate, endDate) {
            var diff = Math.floor((endDate - startDate)/60000),
            hours = Math.floor(diff/60),
            mins = diff - (hours * 60);
            return this._getDatePart(hours,2) + this._getDatePart(mins,2);
        },

        _getUrl_ics: function() {
            var data = this.options.data,
            url = this.options.ics;

            url += (url.indexOf('?') === -1) ? '?' : '&';
            url += 'title=' + encodeURIComponent(data.title);
            url += '&desc=' + encodeURIComponent(data.desc);
            url += '&start=' + this._getUTCTime(data.timeObj.start);
            url += '&end=' + this._getUTCTime(data.timeObj.end);
            url += '&loc=' + encodeURIComponent(data.location);
            url += '&org=' + encodeURIComponent(data.organizer.name);
            url += '&url=' + encodeURIComponent(data.url);
            url += '&offset=' + new Date().getTimezoneOffset();
            return url;
        },

        _getUrl_google: function() {
            var data = this.options.data,
            url = 'http://www.google.com/calendar/event?action=TEMPLATE';
            url += '&text=' + encodeURIComponent(data.title);
            url += '&details=' + encodeURIComponent(data.desc);
            url += '&location=' + encodeURIComponent(data.location);
            url += '&dates=' + encodeURIComponent(this._getUTCTime(data.timeObj.start) + '/' + this._getUTCTime(data.timeObj.end));  // time needs to be sent as UTC and let Google handle converting to local
            url += '&sprop=website:' + encodeURIComponent(data.url);
            url += '&sprop=name:' + encodeURIComponent(data.organizer.name);
            return url;
        },
        _getUrl_yahoo: function() {
            var data = this.options.data,
            url = 'http://calendar.yahoo.com?v=60';
            url += '&TITLE=' + encodeURIComponent(data.title);
            url += '&DESC=' + encodeURIComponent(data.desc);
            url += '&URL=' + encodeURIComponent(data.url);
            url += '&in_loc=' + encodeURIComponent(data.location);
            url += '&ST=' + this._getUTCTime(data.timeObj.start);
            url += '&DUR=' + this._getDateDiff(data.timeObj.start, data.timeObj.end);
            return url;
        },
        _getUrl_hotmail: function() {
            var data = this.options.data,
            url = 'http://calendar.live.com/calendar/calendar.aspx?rru=addevent';
            url += '&summary=' + encodeURIComponent(data.title);
            url += '&location=' + encodeURIComponent(data.location);
            url += '&dtstart=' + this._getUTCTime(data.timeObj.start);
            url += '&dtend=' + this._getUTCTime(data.timeObj.end);
            url += '&description=' + encodeURIComponent(data.desc);
            return url;
        },

        _eventPublisher: function(evt, evtObj) {
            evtObj = evtObj || {};
            evtObj.buttonId = this.el.attr('id');
            evtObj.data = this.options.data;
            $(document).trigger(evt, evtObj);
            if(window.console){
                window.console.log(evt);
                window.console.log(evtObj);
            }
        },

		/*	
		----------------------------
		Public methods
		----------------------------
		*/

		getEventData: function(returnObj) {
            this._sanitizeData();
            returnObj.data = this.options.data;
        },

        update: function(options){
            this._update(options);
        }
    };


	/*	
	----------------------------
	Function
	----------------------------
	*/

	$.fn.addcalevent = function addcalevent_init(options) {

		var thisCall = typeof options;

		switch (thisCall) {

            // allow users to call a specific public method 
        case 'string':
            var args = Array.prototype.slice.call(arguments, 1);
            try{
                this.each(function () {
                    var instance = $.data(this, 'addcalevent');
                    if (!instance) {
                        throw 'Method ' + options + ' cannot be called until addcalevent is setup';
                    }
                    if (!$.isFunction(instance[options]) || options.charAt(0) === '_') {
                        throw 'No such public method ' + options + ' for addcalevent';
                    }
                    // no errors!
                    instance[options].apply(instance, args);
                });
            } catch(err){
                if(window.console){
                    window.console.log(err);
                }
                return false;
            }
            break;

			// attempt to create
        case 'undefined':
        case 'object':
            this.each(function () {
                var instance = $.data(this, 'addcalevent');
                if (instance) {
                    // update options of current instance
                    instance.update(options);
                } else {
                    // initialize new instance
                    instance = new $.addcalevent(options, this);
                    // don't attach if instantiation failed
                    if (!instance.failed) {
                        $.data(this, 'addcalevent', instance);
                    }
                }
            });
            break;
        
        }
        return this;
    };

})(window, jQuery);

/*(function(a){"use strict";a.fn.addToCalendar=function(b){var c={},d=a.extend({filename:"sample",target:"_blank",providers:{google:"Google Calendar",outlook:"Outlook Live",yahoo:"Yahoo! Calendar",other:"Other Calendar"},onAddEvent:function(){}},b),e=function(a,b){var c,e,f,h,i,j,k;if(c=void 0===b.title?"":b.title,e=void 0===b.start?new Date().toISOString():g(b.start),f=void 0===b.end?new Date().toISOString():g(b.end),h=void 0===b.desc?"":b.desc,i=void 0===b.location?"":b.location,k=void 0===b.timezone?"":b.timezone,"google"===a)j="http://www.google.com/calendar/render?action=TEMPLATE",j+="&text="+encodeURIComponent(c),j+="&dates="+encodeURIComponent(e+"/"+f),j+="&details="+encodeURIComponent(h),j+="&location="+encodeURIComponent(i),j+=k?"&ctz="+encodeURIComponent(k):"",j+="&output=xml",window.open(j,d.target);else if("outlook"===a)e=g(b.start,"outlook"),f=g(b.end,"outlook"),j="https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&subject="+encodeURIComponent(c)+"&startdt="+encodeURIComponent(e)+"&enddt="+encodeURIComponent(f)+"&body="+encodeURIComponent(h)+"&location="+encodeURIComponent(i),window.open(j,d.target);else if("yahoo"===a)j="https://calendar.yahoo.com/?v=60&view=d&type=20&title="+encodeURIComponent(c)+"&st="+encodeURIComponent(e)+"&et="+encodeURIComponent(f)+"&desc="+encodeURIComponent(h)+"&in_loc="+encodeURIComponent(i),window.open(j,d.target);else if("other"===a){var l,m=d.filename+".ics",n=new Date().toISOString().split(".")[0].replace(/[/]|-|:/g,""),o="BEGIN:VCALENDAR\n";o+="VERSION:2.0\n",o+="BEGIN:VEVENT\n",o+="DTSTAMP:"+n+"\n",o+="STATUS:CONFIRMED\n",o+="UID:"+new Date().getTime()+"addtocalendar\n",o+=""===k?"DTSTART="+e+"\n":"DTSTART;TZID="+k+":"+e+"\n",o+=""===k?"DTEND="+e+"\n":"DTEND;TZID="+k+":"+f+"\n",o+="SUMMARY:"+c+"\n",o+="DESCRIPTION:"+h+"\n",o+="X-ALT-DESC;FMTTYPE=text/html:"+h+"\n",o+="LOCATION:"+i+"\n",o+="BEGIN:VALARM\n",o+="TRIGGER:-PT15M\n",o+="ACTION:DISPLAY\n",o+="END:VALARM\n",o+="TRANSP:OPAQUE\n",o+="END:VEVENT\n",o+="END:VCALENDAR",l=document.createElement("a"),l.setAttribute("href","data:text/calendar;charset=utf-8,"+encodeURIComponent(o)),l.setAttribute("download",m),l.style.display="none",document.body.appendChild(l),l.click(),document.body.removeChild(l)}else return!1;return!0},f=function(a){var b=document.createElement("ul");return b.className="cal-clients",Object.keys(a).forEach(function(c){var d=document.createElement("li");d.textContent=a[c],d.className=c.toLowerCase(),b.appendChild(d)}),b},g=function(a,b){return"outlook"===b?(a=a.replace(/\//g,"-")+":00",a=a.replace(/\s/,"T")):(a=a.replace(/-|:|[/]|\.\d\d\d/g,"")+"00",a=a.replace(/\s/,"T")),a};return this.each(function(){var b=a(this);b.append(new f(d.providers)).mouseleave(function(){var b=a(this).find(".cal-clients");a(document).click(function(){b.removeClass("is-open"),a(document).unbind("click")})}).on("click",function(b){var d=a(this).find(".cal-clients");b.preventDefault(),c=a(this).data("event"),d.addClass("is-open")}).on("click","li",function(){var b=a(this).attr("class");e(b,c),d.onAddEvent.call(this)})})}})(jQuery);*/
